<template>
  <transition name="fade">
    <div v-if="visible" class="media-overlay" @click.self="close">
      <button class="media-overlay__close" @click="close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6l12 12" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
      <img v-if="type === 'image'" :src="url" class="media-overlay__image" @click.stop />
      <video v-else-if="type === 'video'" :src="url" class="media-overlay__video" controls autoplay @click.stop />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'media-viewer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: null
    },
    url: {
      type: String,
      default: ''
    }
  },
  watch: {
    visible(val) {
      if (val) {
        document.addEventListener('keydown', this.onKeydown);
      } else {
        document.removeEventListener('keydown', this.onKeydown);
      }
    }
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.onKeydown);
  },
  methods: {
    close() {
      this.$emit('close');
    },
    onKeydown(e) {
      if (e.key === 'Escape') {
        this.close();
      }
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.media-overlay {
  position: fixed;
  inset: 0;
  background: rgba(16, 30, 52, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2100;
}

.media-overlay__close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
}

.media-overlay__image {
  max-width: 90vw;
  max-height: 85vh;
  object-fit: contain;
  border-radius: 16px;
}

.media-overlay__video {
  max-width: 90vw;
  max-height: 85vh;
  border-radius: 16px;
}
</style>
